import { GridCustomCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { ILink } from '../../../types/link';
import { openWindow } from '../../../services/openWindow';

export class ContactCell extends React.Component<GridCustomCellProps> {
  public render() {
    return (<td {...this.props.tdProps}>
      <a
        href="#"
        style={{ color: '#007bff' }}
        onClick={(e) => {
          openWindow(this.props.dataItem.Links.find((x: ILink) => x.Name === 'Contact').Link);
          e.preventDefault();
        }}
      >
        {this.props.dataItem.ContactName}
      </a>
    </td>)
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    if (nextProps.dataItem.Hash === this.props.dataItem.Hash) {
        return false;
    }

    return true;
  }
}
